import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const morphLogo = () => {
	const logos = gsap.utils.toArray('.logo-container');

	logos.forEach((logo) => {
		let mql = window.matchMedia("(max-width: 1200px)");
		const mobile = mql.matches;
		const letters = logo.querySelectorAll('.letter');
		const mark = logo.querySelector('.mark');
		const mobileRequestDemoButton = document.querySelector(
			'.mobile-request-demo'
		);

		console.log(mobile);

		const animation = gsap.timeline({
			scrollTrigger: {
				trigger: logo,
				start: 'top top',
				toggleActions: 'play none none reverse',
				onEnterBack: () => {
					if(mobile) {
						mobileRequestDemoButton.classList.remove('active');
					}
				},
			},
			onComplete: () => {
				if(mobile) {
					mobileRequestDemoButton.classList.add('active');
				}
			}
		});

		animation.to(
			letters,
			{
				autoAlpha: 0,
				x: -600,
				duration: 0.5,
				stagger: {
					amount: 0.1,
					ease: 'power4',
				},
			},
			0
		);

		animation.to(
			mark,
			{
				scale: 1.4,
				y: -10,
			},
			0
		);
	});
};

window.addEventListener('DOMContentLoaded', () => {
	morphLogo();
});
